type OrgRoleOption = {
  label: string
  value: string
  description: string
}

export function getOrgRoles(role: string) {
  const isOwner = role === 'owner'

  const memberRole: OrgRoleOption = {
    label: 'Member',
    value: 'member',
    description: 'Track and encourage Workflow activity',
  }

  const mentorRole: OrgRoleOption = {
    label: 'Mentor',
    value: 'mentor',
    description: 'Specialists assigned by an org',
  }

  const editorRole: OrgRoleOption = {
    label: 'Editor',
    value: 'editor',
    description: 'Manage templates',
  }

  const managerRole: OrgRoleOption = {
    label: 'Manager',
    value: 'manager',
    description: 'Manage people and groups and assign workflows',
  }

  const ownerRole: OrgRoleOption = {
    label: 'Owner',
    value: 'owner',
    description: 'Manage the organization',
  }

  return [
    memberRole,
    mentorRole,
    editorRole,
    isOwner && managerRole,
    isOwner && ownerRole,
  ].filter((role): role is OrgRoleOption => !!role)
}
